<template>
	<div class="app--calendar-embed" v-if="!loading && validSrc">
		<iframe v-if="type == 'calendly' || type == null" class="w-100 border-0" :src="computedSrc"></iframe>
		<iframe v-if="type == 'greminders'" class="w-100 border-0" :src="computedSrc"></iframe>
		<iframe v-if="type == 'zoomscheduler'" class="w-100 border-0" :src="computedSrc"></iframe>
		<div v-if="type == 'acuityscheduling'" v-html="computedSrc"></div>
		<div v-if="type == 'scheduleonce'" v-html="computedSrc"></div>
		<div v-if="type == 'zyncal'" v-html="computedSrc"></div>
	</div>
</template>

<script>
import store from '../forms/store'

export default {
	props: {
		type: {
			type: String,
			default: 'calendly'
		},
		src: {
			type: String,
			default: ''
		},
	},
	data: function () {
		return {
			loading: true,
			member: null,
		}
	},
	computed: {
		validSrc() {
			return this.src != ''
		},
		computedSrc() {
			if (this.type === 'greminders') {
				return this.generateGRemindersSrc()
			}

			if (this.type === 'calendly' && this.member) {
				return this.generateCalendlySrc()
			}

			if (this.type === 'zoomscheduler') {
				return this.generateZoomSchedulerSrc();
			}

			return this.src;
		}
	},
	watch: {
		type: {
			immediate: true,
			handler() {
				if (this.type == 'scheduleonce') {
					this._load('https://cdn.oncehub.com/mergedjs/so.js').then(() => {
						this.loading = false
					})
				} else {
					this.loading = false
				}
			}
		}
	},
	methods: {
		_load(src) {
			let JS = new Promise((resolve, reject) => {
				let script = document.createElement('script')
				script.onload = () => {
					resolve('import(JS)')
				}
				script.async = true
				script.src = src
				document.head.appendChild(script)
			})

			return JS
		},
		generateGRemindersSrc() {
			const defaultParams = {
				remember_me: false,
			};

			if (!this.member) {
				return this.appendToSrc(defaultParams);
			}

			const phoneNumber = this.member.phone && this.member.phone.code && this.member.phone.number
				? `${this.member.phone.code}${this.member.phone.number}`
				: null;
			const memberParams = {
				first_name: this.member.first_name || '',
				last_name: this.member.last_name || '',
				email: this.member.email || '',
				phone: phoneNumber || '',
			};
			return this.appendToSrc({...defaultParams, ...this.removeEmptyParams(memberParams)});
		},
		generateCalendlySrc() {
			const memberParams = {
				name: `${this.member.first_name || ''} ${this.member.last_name || ''}`.trim(),
				first_name: this.member.first_name || '',
				last_name: this.member.last_name || '',
				email: this.member.email || '',
				autofill: true
			};
			return this.appendToSrc(this.removeEmptyParams(memberParams));
		},
		generateZoomSchedulerSrc() {
			if (!this.src.includes('?embed=true')) {
				const separator = this.src.includes('?') ? '&' : '?';
				return `${this.src}${separator}embed=true`;
			}
			return this.src;
		},
		appendToSrc(params) {
			const queryParams = new URLSearchParams(params).toString();
			const separator = this.src.includes('?') ? '&' : '?';
			return `${this.src}${separator}${queryParams}`;
		},
		removeEmptyParams(params) {
			return Object.fromEntries(Object.entries(params).filter(([key, value]) => value !== ''));
		}
	},
	mounted() {
		if (store.state.security === 'HIGH') {
			this.member = store.state.members.find(m => m.active === true && m.exists === true);
		}
	}
}
</script>
